// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout_root__3SkNb","wrap":"Layout_wrap__ECukT","colapsar":"Layout_colapsar__3OXhM","content":"Layout_content__3jXZW"};